export default "__VITE_ASSET__BYbvMcUi__"